module.exports = __webpack_public_path__ + "img/test03-1.8f311ec9.jpg";